import { getSemesterArr } from '../../utils/miscelleneous';
import {
    CHECK_EMAIL, RESET_USERS_LIST, GET_STUDENT_LIST, GET_STAFFS, ADD_STAFF, TOGGLE_USER,
    SELECT_ALL_STUDENTS, SELECT_ALL_STAFF, SELECT_ONE_STUDENT, SELECT_ONE_STAFF, VIEW_STUDENT, BACK_TO_USERS,
    GET_CLASSES, GET_SECTION_FROM_CLASS
} from '../Types/types';
let intialState = {
    studentList: [],
    staffList: [],
    sections: [],
    centers: [],
    programs: [],
    semesters: [],
    isListLoading: true,
    isSelectTab: false,
    activeTab: 'staff'
}

export default function userReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case CHECK_EMAIL:
            stateCopy.exists = action.payload;
            return stateCopy;
        case RESET_USERS_LIST:
            stateCopy.isListLoading = true;
            return stateCopy
        case GET_STUDENT_LIST:
            stateCopy.studentList = action.payload.data.data.map(item => ({ ...item, isChecked: false }));
            stateCopy.isListLoading = false;
            stateCopy.studentListCopy = action.payload.data.data.map(item => ({ ...item, isChecked: false }));
            stateCopy.total = action.payload.data.total;
            stateCopy.active = action.payload.data.active;
            stateCopy.inactive = action.payload.data.inactive;
            stateCopy.invited = action.payload.data.invited;
            stateCopy.totalPage = action.payload.data.total_page;
            stateCopy.activeTab = action.payload.role === 'trainee' ? 'trainee' : action.payload.role === 'student' ? 'student' : 'corporate-trainee';
            return stateCopy;

        case GET_STAFFS:
            stateCopy.staffList = action.payload.data.map(item => ({ ...item, isChecked: false }));
            stateCopy.staffListCopy = action.payload.data.map(item => ({ ...item, isChecked: false }));
            stateCopy.isListLoading = false;
            stateCopy.totalStaff = action.payload.total;
            stateCopy.activeStaff = action.payload.active;
            stateCopy.inactiveStaff = action.payload.inactive;
            stateCopy.invitedStaff = action.payload.invited;
            stateCopy.totalStaffpage = action.payload.total_page;
            stateCopy.activeTab = 'staff';
            return stateCopy;
        case ADD_STAFF:
            stateCopy.activeTab = 'staff';
            return stateCopy;
        case TOGGLE_USER:
            if (action.payload.type === 'student' || action.payload.type === 'trainee') {
                stateCopy.studentList.forEach(element => {
                    if (element._id === action.payload.id) {
                        element.active = (element.active ? false : !element.active ? true : 'invited');
                    }
                });
            }
            else {
                stateCopy.staffList.forEach(element => {
                    if (element._id === action.payload.id) {
                        element.active = (element.active ? false : !element.active ? true : 'invited');
                    }
                });
            }
            return stateCopy;

        case SELECT_ALL_STUDENTS:
            if (action.payload) {
                stateCopy.studentList = stateCopy.studentList.map(item => ({ ...item, isChecked: true }));
                stateCopy.studentListCopy = stateCopy.studentListCopy.map(item => ({ ...item, isChecked: true }));
            }
            else {
                stateCopy.studentList = stateCopy.studentList.map(item => ({ ...item, isChecked: false }));
                stateCopy.studentListCopy = stateCopy.studentListCopy.map(item => ({ ...item, isChecked: false }));
            }
            return stateCopy
        case SELECT_ALL_STAFF:
            if (action.payload) {
                stateCopy.staffList = stateCopy.staffList.map(item => ({ ...item, isChecked: true }));
                stateCopy.staffListCopy = stateCopy.staffListCopy.map(item => ({ ...item, isChecked: true }));
            }
            else {
                stateCopy.staffList = stateCopy.staffList.map(item => ({ ...item, isChecked: false }));
                stateCopy.staffListCopy = stateCopy.staffListCopy.map(item => ({ ...item, isChecked: false }));
            }
            return stateCopy
        case SELECT_ONE_STUDENT:
            if (action.payload.checked) {
                stateCopy.studentList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = true
                    }
                })
            }
            else {
                stateCopy.studentList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = false
                    }
                })
            }
            return stateCopy;
        case SELECT_ONE_STAFF:
            if (action.payload.checked) {
                stateCopy.staffList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = true
                    }
                })
            }
            else {
                stateCopy.staffList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = false
                    }
                })
            }
            return stateCopy;
        case VIEW_STUDENT:
            stateCopy.student = stateCopy.studentList.filter(el => el._id === action.payload)[0];
            stateCopy.isView = true;
            return stateCopy;
        case BACK_TO_USERS:
            stateCopy.student = {};
            stateCopy.isView = false;
            return stateCopy;

        case GET_CLASSES:
            stateCopy.classes = action.payload.map(el => [{ ...el, label: `Class ${el.class} - ${el.affiliation[0]?.name}`, value: el._id }][0]);
            return stateCopy;
        case GET_SECTION_FROM_CLASS:
            stateCopy.sectionOfClass = action.payload.map(el => [{ label: `Section ${el.name}`, value: el._id }][0]);
            return stateCopy;


        case 'Get_Search_List':
            stateCopy.studentList = action.payload.data.map(item => ({ ...item, isChecked: false }));
            return stateCopy


        case 'Get_All_Center':
            stateCopy.centers = action.payload.map(el => [{ value: el._id, label: el.title, value1: 'center' }][0]).sort((a, b) => a.label.localeCompare(b.label));
            return stateCopy;
        case 'Get_All_Sections':
            if (action.payload.type === 'batch') {
                stateCopy.batches = action.payload.data.map(el => [{ value: el._id, label: el.title, program_id: el.program._id, semester: el.program.semester, value1: 'section' }][0]);
            } else if (action.payload.type === 'corporate') {
                stateCopy.corporateBatches = action.payload.data.map(el => [{ value: el._id, label: el.title, program_id: el.program._id, semester: el.program.semester, value1: 'section' }][0]);
            }
            else {
                stateCopy.sections = action.payload.data.map(el => [{ value: el._id, label: el.title, program_id: el.program._id, semester: el.program.semester, value1: 'section' }][0]);
            }
            return stateCopy;

        case 'Get_Semester_From_Program':
            const total = stateCopy.programsCopy.filter(el => el._id === action.payload)[0].semester;
            stateCopy.semesters = getSemesterArr(total);
            return stateCopy;
        case 'Get_All_Programs':
            stateCopy.programsCopy = action.payload;
            stateCopy.programs = stateCopy.programsCopy.map(el => [{ value: el._id, label: el.program, type: el.type, value1: 'program' }][0]).sort((a, b) => a.label.localeCompare(b.label));
            return stateCopy;
        case 'Get_All_Subject':
            stateCopy.subjects = action.payload.map(el => [{ value: el._id, label: el.title, value1: 'subject' }][0]).sort((a, b) => a.label.localeCompare(b.label));
            return stateCopy;
        case 'Get_All_Default_Subject':
            stateCopy.subjects = stateCopy.subjects.concat(action.payload.map(el => [{ value: el._id, label: el.title, value1: 'subject' }][0]).sort((a, b) => a.label.localeCompare(b.label)))
            return stateCopy;
        case 'Get_Filtered_List':
            stateCopy.studentList = action.payload.data;
            stateCopy.total = action.payload.total;
            stateCopy.active = action.payload.active;
            stateCopy.inactive = action.payload.inactive;
            stateCopy.invited = action.payload.invited;
            stateCopy.totalPage = action.payload.total_page;
            stateCopy.isListLoading = false;
            return stateCopy;
        case 'Get_Filtered_Staff_List':
            stateCopy.staffList = action.payload.data;
            stateCopy.totalStaff = action.payload.total;
            stateCopy.activeStaff = action.payload.active;
            stateCopy.inactiveStaff = action.payload.inactive;
            stateCopy.invitedStaff = action.payload.invited;
            stateCopy.totalStaffpage = action.payload.total_page;
            stateCopy.isListLoading = false;
            return stateCopy;
        case 'Clear_Student_Filters':
            // if (action.payload === 'student') {
            //     stateCopy.studentList = stateCopy.studentListCopy;
            // }
            // else {
            //     stateCopy.staffList = stateCopy.staffListCopy;
            // }
            return stateCopy;



        default:
            return stateCopy;
    }
}

